"use client"

import { buttonVariants } from "@/components/ui/button"
import { useEffect, useState } from "react"

export const DeviceDetailedSecx = ({ data }: { data: any }) => {

  const mockFeatures = data?.deviceFeatures

  const deviceFeatures =
    data?.deviceFeatures && data?.deviceFeatures?.length !== 0
      ? data?.deviceFeatures
      : mockFeatures


  const sections = [
    "Product Description",
    "Technical Specs",
    "Additional Details",
  ]

  const totalBlocks = 1 + deviceFeatures.length
  const leftCount = Math.ceil(totalBlocks / 2) - 1

  const leftFeatures = deviceFeatures.slice(0, leftCount)
  const rightFeatures = deviceFeatures.slice(leftCount)

  return (
    <section className="flex lg:px-8 flex-col sm:py-16 sm:gap-10 gap-4 py-8 mx-auto ">
      <h1 className="sm:text-4xl text-xl font-orange text-center pb-4">
        Specification
      </h1>

      {/* SPECIFICATION SECTION */}

      <div className="bg-[#F7F7F7] rounded-[10px] w-full mx-auto flex flex-col md:flex-row justify-between items-start py-8 md:py-12 gap-10">
        {/* Left Half */}
        <div className="flex flex-col gap-10 w-full md:w-1/2">
          <div>
            <h1 className="sm:text-2xl text-xl font-orange px-6 md:px-11">
              Details
            </h1>
            <p className="py-3.5 px-6 md:px-11 font-gilroyMedium text-sm sm:text-base">
              {data?.description}. For more refurbished laptops visit <a href="https://edify.club/refurbished-laptops" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Refurbished Laptops</a>
            </p>
          </div>

          {leftFeatures.map((feat) => (
            <div key={feat?.title} className="flex flex-col gap-4">
              <h3 className="sm:text-2xl text-xl font-orange px-6 md:px-11">
                {feat?.title}
              </h3>
              <div className="flex flex-col gap-3">
                {feat?.features?.map((v) => (
                  <div
                    key={v?.title}
                    className="px-6 md:px-11 font-gilroyMedium text-sm sm:text-base"
                  >
                    <div className="flex items-center justify-between w-full">
                      <span>{v?.title}</span>
                      <span className="text-sm flex items-center justify-end">
                        {v?.value}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Right Half */}
        <div className="flex flex-col gap-10 md:gap-[140px] lg:gap-28 xl:gap-24 w-full md:w-1/2">
          {rightFeatures.map((feat) => (
            <div key={feat?.title} className="flex flex-col gap-4">
              <h3 className="sm:text-2xl text-xl font-orange px-6 md:px-11">
                {feat?.title}
              </h3>
              <div className="flex flex-col gap-3">
                {feat?.features?.map((v) => (
                  <div
                    key={v?.title}
                    className="px-6 md:px-11 font-gilroyMedium text-sm sm:text-base"
                  >
                    <div className="flex items-center justify-between w-full">
                      <span>{v?.title}</span>
                      <span className="text-sm flex items-center justify-end">
                        {v?.value}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
